<template>
  <app-layout title="Organisations">
    <div class="full">
      <div class="grid grid-cols-3 gap-4">
        <div class="left">
          <img :src="'/imgs/rocket.png'" alt="" class="left-text ml-2" />
        </div>
        <!-- ... -->
        <div class="col-span-2 h-auto mt-2 pb-4" style="border: none">
          <!-- right card -->
          <div class="grid grid-cols-4 gap-4">
            <div class="col-span-3 mt-5">
              <!-- progress bar start from here -->
              <!-- progress end  -->
              <div class="mt-5 ml-5">
                <!-- card start -->

                <div
                  class="rounded my-5 p-3 border-solid border-2 border-light-blue-500"
                  style="background-color: #f4f7ff"
                >
                  <h4 class="font-bold">Thankyou for your purchase !</h4>
                  <p class="text-md font-medium">
                    You have successfully subscribed for
                    <span class="font-semibold">{{ productName }}</span>
                  </p>
                  <p class="text-sm text-gray-500">
                    If you would like to deploy the product to a custom site,
                    click the button below:
                  </p>
                  <!-- button -->
                  <div class="d-flex justify-between mt-4">
                    <div class="text-sm mt-2">
                      <input type="checkbox" id="checkbox" v-model="checked" />
                      Do you want to Assign License to yourself ?
                    </div>
                    <button
                      @click="deployProductModule()"
                      type="button"
                      class="rounded-md font-bold bg-green-500 text-white px-3 py-1"
                    >
                      Install Now &nbsp;
                      <i
                        class="fa fa-long-arrow-right mt-2"
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>

                  <!-- button end -->
                </div>

                <!-- card end -->
              </div>
            </div>
            <!-- ... -->
            <div></div>
          </div>
          <!--right card end -->
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";

export default {
  props: {
    organisationHost: String,
    subscriptionProductId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptinPriceId: String,
    productName: String,
    subscriptionId: String,
  },

  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
  },
  data() {
    return {
      checked: true,
    };
  },
  methods: {
    deployProductModule() {
      var data = {
        subscriptionProductId: this.subscriptionProductId,
        organisationHost: this.organisationHost,
        organisationId: this.organisationId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptinPriceId: this.subscriptinPriceId,
        subscriptionId: this.subscriptionId,
        assignRole: this.checked,
      };

      this.$inertia.post(route("marketplaces.deployproductmodule"), data);
    },
  },
  mounted() {},
};
</script>

<style>
a {
  text-decoration: none !important;
}
/* .select:hover{
  background: #B8E3CF !important;
} */
.left-text {
  margin-top: 11rem;
}
.full {
  background-color: #ffffff;
  height: 91vh;
  background-size: cover;
  overflow: hidden;
}

p {
  margin-bottom: 0.1rem;
}
h6,
h3,
h2 {
  margin-bottom: 0.03rem;
}

.left {
  background-color: #eff3f2;
  height: 91vh;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 0.45rem;
}
input[type="checkbox"] {
  color: #29aa5c;
}
</style>